import React from 'react';
import { Container, Typography, Box, Paper, Breadcrumbs, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';
import GavelIcon from '@mui/icons-material/Gavel';

const Termos: React.FC = () => {
  return (
    <Box sx={{ minHeight: '80vh', py: 4, backgroundColor: '#f8f9fa' }}>
      <Container maxWidth="md">
        <Breadcrumbs sx={{ mb: 3 }}>
          <MuiLink component={Link} to="/" color="inherit" underline="hover">
            Início
          </MuiLink>
          <Typography color="text.primary">Termos de Uso</Typography>
        </Breadcrumbs>

        <Paper elevation={0} sx={{ p: { xs: 3, md: 5 }, borderRadius: 3, border: '1px solid #e0e0e0' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
            <Box
              sx={{
                width: 48,
                height: 48,
                borderRadius: '12px',
                bgcolor: 'rgba(194, 53, 53, 0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#C23535',
              }}
            >
              <GavelIcon sx={{ fontSize: 28 }} />
            </Box>
            <Box>
              <Typography variant="h4" component="h1" fontWeight={700} color="#202529">
                Termos de Uso
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Última atualização: Setembro de 2026 • IDECONECTA / IDEBRASIL
              </Typography>
            </Box>
          </Box>

          <Typography paragraph sx={{ lineHeight: 1.8 }}>
            Bem-vindo ao <strong>IDECONECTA</strong>. Ao acessar o site ou utilizar os aplicativos móveis oficiais da plataforma, você concorda em cumprir e vincular-se aos presentes Termos e Condições de Uso. Caso não concorde com algum dos termos aqui descritos, você não deverá utilizar a plataforma.
          </Typography>

          <Typography variant="h6" fontWeight={700} sx={{ mt: 4, mb: 1, color: '#202529' }}>
            1. Natureza do Serviço e Comunidade Exclusiva
          </Typography>
          <Typography paragraph sx={{ lineHeight: 1.8 }}>
            O IDECONECTA é um ambiente de conexões B2B e catálogo de empresas direcionado primordialmente aos empresários, alunas e alunos capacitados pelos cursos e programas do <strong>IDEBRASIL</strong>. O acesso à área restrita de publicação é validado mediante verificação de CPF/CNPJ previamente cadastrado.
          </Typography>

          <Typography variant="h6" fontWeight={700} sx={{ mt: 4, mb: 1, color: '#202529' }}>
            2. Responsabilidade pelas Informações Publicadas
          </Typography>
          <Typography paragraph sx={{ lineHeight: 1.8 }}>
            Cada empresa e usuário é inteiramente responsável pela veracidade, legalidade e precisão dos dados, fotos, contatos e serviços oferecidos. É expressamente proibido:
          </Typography>
          <ul>
            <li>Cadastrar dados falsos, enganosos ou que violem direitos de terceiros ou marcas registradas;</li>
            <li>Divulgar atividades ilícitas, produtos proibidos ou serviços incompatíveis com as diretrizes do ecossistema IDEBRASIL;</li>
            <li>Praticar qualquer ato que comprometa a estabilidade técnica e segurança da plataforma.</li>
          </ul>

          <Typography variant="h6" fontWeight={700} sx={{ mt: 4, mb: 1, color: '#202529' }}>
            3. Moderação e Aprovação de Perfis
          </Typography>
          <Typography paragraph sx={{ lineHeight: 1.8 }}>
            A equipe gestora do IDECONECTA reserva-se o direito de analisar, aprovar, reprovar ou suspender temporariamente cadastros de empresas que não atendam aos critérios de qualidade, confiabilidade e governança da comunidade.
          </Typography>

          <Typography variant="h6" fontWeight={700} sx={{ mt: 4, mb: 1, color: '#202529' }}>
            4. Negociações entre Membros
          </Typography>
          <Typography paragraph sx={{ lineHeight: 1.8 }}>
            O IDECONECTA atua como um facilitador de conexões e visibilidade empresarial. Qualquer contratação, orçamento, compra ou venda realizada diretamente entre as empresas cadastradas é de responsabilidade exclusiva das partes negociantes.
          </Typography>

          <Typography variant="h6" fontWeight={700} sx={{ mt: 4, mb: 1, color: '#202529' }}>
            5. Encerramento e Exclusão de Conta
          </Typography>
          <Typography paragraph sx={{ lineHeight: 1.8 }}>
            O usuário pode solicitar o cancelamento e exclusão de seus dados a qualquer momento pelo aplicativo ou pelo canal de <MuiLink component={Link} to="/excluir-conta" color="primary" fontWeight={600}>Exclusão de Conta</MuiLink>. O IDECONECTA também poderá desativar contas que violem os presentes Termos de Uso.
          </Typography>

          <Typography variant="h6" fontWeight={700} sx={{ mt: 4, mb: 1, color: '#202529' }}>
            6. Foro e Legislação Aplicável
          </Typography>
          <Typography paragraph sx={{ lineHeight: 1.8 }}>
            Estes Termos são regidos pelas leis da República Federativa do Brasil, em especial o Código de Defesa do Consumidor e a Lei Geral de Proteção de Dados (LGPD).
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default Termos;
